import { WithStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import withStyles from "@material-ui/core/styles/withStyles";
import { inject, observer } from "mobx-react";
import React from "react";
import { CommonsStore } from "../../model/CommonsStore";
import { TitleRow } from "../Views/TitleRow";

const styles = (theme: Theme) => {
  return {
    title: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      maxWidth: "600px"
    },
    titleText: {
      verticalAlign: "middle"
    },
    cardContent: {
      padding: "0 !important",
      overflow: "hidden",
      height: "892px"
    },
    iFrame: {
      width: "100%",
      height: "100%",
      border: "none",
      margin: "0px",
      padding: "0px",
      display: "block"
    }
  };
};

export interface FrameProps extends WithStyles<typeof styles> {
  title: string;
  link?: string;
  commons?: CommonsStore;
}

@inject("commons")
@observer
class IFrameComponent extends React.Component<FrameProps> {
  public constructor(props: FrameProps) {
    super(props);
  }

  public render() {
    const { classes } = this.props;
    if (this.props.commons) {
      this.props.commons.resetDataExchange();
    }

    return (
      <>
        <TitleRow title={this.props.title} classes={classes} />
        <Card>
          <CardContent className={classes.cardContent}>
            <iframe src={this.props.link} className={classes.iFrame} />
          </CardContent>
        </Card>
      </>
    );
  }
}

export const IFrame = withStyles(styles, { withTheme: true })(IFrameComponent);
